<template>
  <v-footer id="the-footer" height="auto" color="grey darken-1" absolute app>
    <v-layout justify-center row wrap>
      <v-flex text-xs-center pt-3 white--text>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              flat
              color="white"
              href="https://www.facebook.com/PRPropertiesGroup"
              target="_blank"
              v-on="on"
            >
              <!--          <svg-->
              <!--            aria-labelledby="simpleicons-facebook-icon"-->
              <!--            role="img"-->
              <!--            viewBox="0 0 24 24"-->
              <!--            xmlns="http://www.w3.org/2000/svg"-->
              <!--          >-->
              <!--            <title id="simpleicons-facebook-icon">Facebook icon</title>-->
              <!--            <path-->
              <!--              fill="white"-->
              <!--              d="M22.676 0H1.324C.593 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294H9.689v-3.621h3.129V8.41c0-3.099 1.894-4.785 4.659-4.785 1.325 0 2.464.097 2.796.141v3.24h-1.921c-1.5 0-1.792.721-1.792 1.771v2.311h3.584l-.465 3.63H16.56V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .593 23.408 0 22.676 0"-->
              <!--            ></path>-->
              <!--          </svg>-->
              <v-icon dark>fab fa-facebook-f</v-icon>
            </v-btn>
          </template>
          <span>Facebook</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              flat
              href="https://twitter.com/PRProperties"
              target="_blank"
              v-on="on"
            >
              <!--          <svg-->
              <!--            aria-labelledby="simpleicons-twitter-icon"-->
              <!--            role="img"-->
              <!--            viewBox="0 0 24 24"-->
              <!--            xmlns="http://www.w3.org/2000/svg"-->
              <!--          >-->
              <!--            <title id="simpleicons-twitter-icon">Twitter icon</title>-->
              <!--            <path-->
              <!--              fill="white"-->
              <!--              d="M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z"-->
              <!--            ></path>-->
              <!--          </svg>-->
              <v-icon dark color="white">fab fa-twitter</v-icon>
            </v-btn>
          </template>
          <span>Twitter</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              flat
              href="http://www.trulia.com/profile/PhilipRoy/"
              target="_blank"
              v-on="on"
            >
              <!--          <svg-->
              <!--            aria-labelledby="simpleicons-trulia-icon"-->
              <!--            role="img"-->
              <!--            viewBox="0 0 24 24"-->
              <!--            xmlns="http://www.w3.org/2000/svg"-->
              <!--          >-->
              <!--            <title id="simpleicons-trulia-icon">Trulia icon</title>-->
              <!--            <path-->
              <!--              fill="white"-->
              <!--              d="M12 0C8.19.021 5.729 2.58 5.729 6.445c0 3.201 2.088 5.94 3.277 10.1.684 2.385 1.052 5.303 1.242 7.455h3.504c.192-2.152.558-5.07 1.241-7.455 1.189-4.16 3.277-6.898 3.277-10.1C18.271 2.58 15.81.021 12 0zm.02 9.852c-1.584 0-2.869-1.286-2.869-2.869 0-1.582 1.285-2.867 2.869-2.867 1.585 0 2.869 1.283 2.869 2.867s-1.285 2.869-2.869 2.869z"-->
              <!--            ></path>-->
              <!--          </svg>-->
              <v-icon dark color="white">fas fa-map-marker-alt</v-icon>
            </v-btn>
          </template>
          <span>Trulia</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              flat
              href="http://www.youtube.com/user/PhilipARoy"
              target="_blank"
              v-on="on"
            >
              <!--          <svg-->
              <!--            aria-labelledby="simpleicons-youtube-icon"-->
              <!--            role="img"-->
              <!--            xmlns="http://www.w3.org/2000/svg"-->
              <!--            viewBox="0 0 24 24"-->
              <!--          >-->
              <!--            <title id="simpleicons-youtube-icon">YouTube icon</title>-->
              <!--            <path-->
              <!--              fill="white"-->
              <!--              d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"-->
              <!--            ></path>-->
              <!--          </svg>-->
              <v-icon dark color="white">fab fa-youtube</v-icon>
            </v-btn>
          </template>
          <span>YouTube</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              flat
              href="https://www.linkedin.com/in/philip-roy-61323222/"
              target="_blank"
              v-on="on"
            >
              <!--          <svg-->
              <!--            aria-labelledby="simpleicons-linkedin-icon"-->
              <!--            role="img"-->
              <!--            viewBox="0 0 24 24"-->
              <!--            xmlns="http://www.w3.org/2000/svg"-->
              <!--          >-->
              <!--            <title id="simpleicons-linkedin-icon">LinkedIn icon</title>-->
              <!--            <path-->
              <!--              fill="white"-->
              <!--              d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"-->
              <!--            ></path>-->
              <!--          </svg>-->
              <v-icon dark color="white">fab fa-linkedin-in</v-icon>
            </v-btn>
          </template>
          <span>LinkedIn</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              flat
              href="https://www.pinterest.com/philiparoy/"
              target="_blank"
              v-on="on"
            >
              <!--          <svg-->
              <!--            aria-labelledby="simpleicons-pinterest-icon"-->
              <!--            role="img"-->
              <!--            viewBox="0 0 24 24"-->
              <!--            xmlns="http://www.w3.org/2000/svg"-->
              <!--          >-->
              <!--            <title id="simpleicons-pinterest-icon">Pinterest icon</title>-->
              <!--            <path-->
              <!--              fill="white"-->
              <!--              d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"-->
              <!--            ></path>-->
              <!--          </svg>-->
              <v-icon dark color="white">fab fa-pinterest-p</v-icon>
            </v-btn>
          </template>
          <span>Pinterest</span>
        </v-tooltip>
      </v-flex>
      <v-flex text-xs-center xs12 py-3 white--text>
        &copy; {{ year }} - PR Properties Group
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  name: 'TheFooter',
  data() {
    return {
      fixed: false,
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
svg {
  height: 24px;
  width: 24px;
}

#the-footer {
  z-index: 999;
}
</style>
